import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-grid">
          <div className="footer-column">
            <h4 className="footer-title">COMPANY</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/dlas">DLAs</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h4 className="footer-title">LOANS</h4>
            <ul className="footer-links">
              <li><Link to="/loans/property">Loan against Property</Link></li>
              <li><Link to="/loans/shares">Loan against Shares</Link></li>
              <li><Link to="/loans/personal">Personal Loan</Link></li>
              <li><Link to="/loans/used-vehicle">Used Vehicle Loan</Link></li>
              <li><Link to="/loans/msme">MSME Loan</Link></li>
              <li><Link to="/loans/invoice-discounting">Invoice Discounting</Link></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h4 className="footer-title">POLICIES</h4>
            <ul className="footer-links">
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
              <li><Link to="/policies">Policies</Link></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h4 className="footer-title">FOLLOW US</h4>
            <div className="follow-us-content">
              <p className="follow-description">
                Stay connected with us for the latest insights and updates!
              </p>
              <div className="social-icons">
                <a href="#linkedin" className="social-icon linkedin">
                  <span>in</span>
                </a>
                <a href="#facebook" className="social-icon facebook">
                  <span>f</span>
                </a>
                <a href="#twitter" className="social-icon twitter">
                  <span>🐦</span>
                </a>
                <a href="#youtube" className="social-icon youtube">
                  <span>▶</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p className="copyright">All Rights Reserved. Copyright © 2024 Ampire Finance</p>
          <div className="scroll-to-top" onClick={scrollToTop}>▲</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
